module.exports = __webpack_public_path__ + "img/icon_report.2903c033.png";